export default __webpack_public_path__ + "static/media/(22).920acdf3.jpeg";